import { memo, useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import ObjectActionCreators from '../../../actions';
import { remoteControllerShowToggle } from '../../../reducers/layoutReducer/action';
import { currentPaletteActiveSelector } from '../../../reducers/themeReducers/themeSelector';
import NavigHeader from './NavigHeader';
import { userPrivSelector } from '../../../reducers/authReducer/authSelector';
import { makeSelectShouldDisplayCardTopHeader } from '../DataColumns/DataColumnsUtils';

const displayModeSelector = (state) => state.objects?.displayMode ?? [];
const panelsSelector = (state) => state.objects?.panels ?? [];

const makeMapStateToProps = () => {
  // Mémo: calcul des displayModes "forcés stack si width < 300"
  const calculatedDisplayModesSelector = createSelector(
    [displayModeSelector, panelsSelector],
    (displayModes, panels) =>
      displayModes.map((mode, index) =>
        (panels[index]?.width ?? Infinity) < 300 ? 'stack' : mode
      )
  );

  // Instancie ton petit selector une seule fois par instance
  const selectShowCardTop = makeSelectShouldDisplayCardTopHeader();

  // mapStateToProps réel
  return (state, ownProps) => {
    const level = Number(ownProps.level) || 0;

    const calculatedDisplayModes = calculatedDisplayModesSelector(state);
    const showCardTop = selectShowCardTop(state, level); // <- passe un nombre, pas un tableau

    return {
      activeBand: state.objects.activeBand,
      arrayParamClassif: state.objects.arrayParamClassif,
      arrayStatBy: state.objects.arraySortBy,
      dicoNameRef: state.objects.dicoNameRef,
      displayMode: calculatedDisplayModes[level],
      dragged_over: state.objects.dragged_over,
      objectsDefList: state.objects.objectsDefList,
      nbMandatoryLevel: isNaN(state.objects.mandatoryLevel)
        ? 0
        : Number(state.objects.mandatoryLevel),
      pal: currentPaletteActiveSelector(state),
      qb_restrictions: state.QBUILDER.qb_restrictions,
      restrictions: state.objects.restrictions,
      sortByKey: state.objects.arraySortBy?.[level],
      type: state.objects.arrayClassifBy?.[level],
      timeline_shift: state.objects.timeline_shift,
      userPriv: userPrivSelector(state),
      showCardTop,
    };
  };
};

const mapDispatchToProps = (dispatch) => ({
  addFieldRestriction: (
    field,
    value,
    objectType,
    fieldType,
    comparator,
    level
  ) =>
    dispatch(
      ObjectActionCreators.addFieldRestriction(
        field,
        value,
        objectType,
        fieldType,
        comparator,
        level
      )
    ),
  timelineShift: (level, shift) =>
    dispatch(ObjectActionCreators.timelineShift(level, shift)),
  toggleDisplayMode: (level) =>
    dispatch(ObjectActionCreators.toggleDisplayMode(level)),
  toggleMandatoryLevel: (level) =>
    dispatch(ObjectActionCreators.toggleMandatoryLevel(level)),
  setActivePanel: (level) =>
    dispatch(ObjectActionCreators.setActivePanel(level)),
  setSortBy: (param, level) =>
    dispatch(ObjectActionCreators.setSortBy(param, level)),
  setStatBy: (param, level) =>
    dispatch(ObjectActionCreators.setStatBy(param, level)),
  expandNodes: (level) => dispatch(ObjectActionCreators.expandNodes(level)),
  collapseNodes: (level) => dispatch(ObjectActionCreators.collapseNodes(level)),

  remoteControllerShowToggle: (x, y) =>
    dispatch(remoteControllerShowToggle(x, y)),
  setQBRestrictionByLevel: (level, object, str, strraw) =>
    dispatch(
      ObjectActionCreators.setQBRestrictionByLevel(level, object, str, strraw)
    ),
  selectObject: (objId) => dispatch(ObjectActionCreators.selectObject(objId)),
  openObjectMenu: (action) =>
    dispatch(ObjectActionCreators.openObjectMenu(action)),
  setObjectToCreate: (type) =>
    dispatch(ObjectActionCreators.setObjectToCreate(type)),
  setActivePanelHeader: (level) =>
    dispatch(ObjectActionCreators.setActivePanelHeader(level)),
});

export default memo(
  withTranslation()(
    connect(makeMapStateToProps, mapDispatchToProps, null)(NavigHeader)
  )
);
